import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles';

const useStyles = createUseStyles(
  {
    '@keyframes spinner': {
      from: {
        transform: ' rotate(0deg)',
      },
      to: {
        transform: ' rotate(360deg);',
      },
    },

    loaderContainer: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: 8,

      '& img': {
        maxWidth: '100%',
        verticalAlign: 'top',
        display: 'inline-block',
      },
    },

    text: {
      fontSize: 20,
      fontWeight: FontWeight.Bold,
      color: 'var(--x-text-color-2)',
    },

    loader: {
      animationName: '$spinner',
      animation: 'spinner 2s linear infinite',
    },
  },
  {
    name: 'processing-widget',
  },
);

export default useStyles;
